import axios from 'axios';

export const trimTextForPreview = (string, max = 24) => {
    const words = string.split(' ');
    if (words.length <= max) {
        return string.trim();
    }

    return `${words.slice(1, max).join(' ').trim()}...`;
};

export const loadEmailDraft =  (draftId) => {
    //console.log('loadEmailDraft draftId =>', draftId);
    return axios({
        method: 'get',
        url: `/api/v3/email_draft/${draftId}`,
        baseURL: process.env.REACT_APP_API_ROOT,
    })
    .then((response) => {
        //console.log('loadEmailDraft response =>', response);
        return response.data.data;
    })
    .catch((error) => {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    })
}

export const createOrUpdateEmailDraft =  (data) => {
    //console.log('createOrUpdateEmailDraft data =>', data);
    return axios({
        method: 'post',
        url: '/api/v3/email_draft/create_or_update',
        baseURL: process.env.REACT_APP_API_ROOT,
        data: data==null ? {} : data,
    })
    .then((response) => {
        //console.log('createOrUpdateEmailDraft response =>', response);
        return response.data;
    })
    .catch((error) => {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    })
};

export const deleteEmailDraft =  (draftId) => {
    //console.log('deleteEmailDraft draftId =>', draftId);
    return axios({
        method: 'delete',
        url: `/api/v3/email_draft/${draftId}`,
        baseURL: process.env.REACT_APP_API_ROOT,
    })
    .then((response) => {
        //console.log('deleteEmailDraft response =>', response);
        return response.data;
    })
    .catch((error) => {
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw error;
    })
};